export enum NetworkRequestStatus {
    Loading = 'loading',
    Error = 'error',
    Success = 'success',
}

export interface Loading {
    status: NetworkRequestStatus.Loading;
    message?: string | null;
}

export interface ErrorResponse {
    status: NetworkRequestStatus.Error;
}

export interface SuccessResponse<T> {
    status: NetworkRequestStatus.Success;
    data: T;
}

export interface DoubleSuccessResponse<TA, TB> {
    status: NetworkRequestStatus.Success;
    first: TA;
    second: TB;
}

export type NetworkResult<T> = Loading | ErrorResponse | SuccessResponse<T>;

export function combineDouble<T, K>(a: NetworkResult<T>, b: NetworkResult<K>): NetworkResult<[T, K]> {
    if (a.status === NetworkRequestStatus.Loading || b.status === NetworkRequestStatus.Loading) {
        return loadingResponse();
    }
    if (a.status === NetworkRequestStatus.Error || b.status === NetworkRequestStatus.Error) {
        return errorResponse();
    }
    return successResponse([a.data, b.data]);
}

export function combineTriple<T, K, L>(
    a: NetworkResult<T>,
    b: NetworkResult<K>,
    c: NetworkResult<L>,
): NetworkResult<[T, K, L]> {
    if (
        a.status === NetworkRequestStatus.Loading ||
        b.status === NetworkRequestStatus.Loading ||
        c.status === NetworkRequestStatus.Loading
    ) {
        return loadingResponse();
    }
    if (
        a.status === NetworkRequestStatus.Error ||
        b.status === NetworkRequestStatus.Error ||
        c.status === NetworkRequestStatus.Error
    ) {
        return errorResponse();
    }
    return successResponse([a.data, b.data, c.data]);
}

export function loadingResponse(message: string | null = null): Loading {
    return {
        status: NetworkRequestStatus.Loading,
        message,
    };
}

export function errorResponse(): ErrorResponse {
    return {
        status: NetworkRequestStatus.Error,
    };
}

export function successResponse<T>(data: T): SuccessResponse<T> {
    return {
        status: NetworkRequestStatus.Success,
        data,
    };
}
